// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';

const Section = (props) => {

    return (
        <div
            className={`${props.removeContainer ? "" : "container"} ${props.fullWidth ? "container-fluid" : ""} ${props.className ? props.className : ""}`}
            style={props.containerStyle}
        >
            <div
                className={`row ${props.rowClassName ? props.rowClassName : ""}`}
                style={props.rowStyle}
            >
                {props.children}
            </div>
        </div>
    );
}

Section.propTypes = {
    // SIZE AND APPEARANCE PROPS
    className: PropTypes. string,
    rowClassName: PropTypes.string,
    containerStyle: PropTypes.string,
    rowStyle: PropTypes.object,
    

    // BOOLEAN PROPS
    removeContainer: PropTypes.bool,
    fullWidth: PropTypes.bool,
}

export default Section;